import { STOModel } from "src/models/base/sto-model";
import { ListSortDirection } from "../../models/api/sort/list-sort-direction";
import { Sort } from "../../models/api/sort/sort";
import { TnAOverviewDTO } from "../../models/tna-overviews";
import { BaseApiService } from "../base/base-api.service";

export class TnAOverviewsApiService extends BaseApiService<TnAOverviewDTO, STOModel> {
  constructor() {
    super({
      servicePath: "/TnAOverviews",
      loadItemsPath: "/GetTnAOverviews",
    });
    this.defaultSort = [
      {
        name: "workedTimeBalance",
        direction: ListSortDirection.Descending,
      } as Sort,
    ];
  }
}
